import fetchWithDefaults from '../CommonUtils/fetchWithDefaults';
import { urlWithParams } from '../CommonUtils/urlWithParams';

export const RECEIVE_CURRENT_ASSET_ALLOCATION_DATA = 'RECEIVE_CURRENT_ASSET_ALLOCATION_DATA';

export const receive_current_asset_allocation_data = (resp, clientId) => ({
  type: RECEIVE_CURRENT_ASSET_ALLOCATION_DATA,
  data: resp,
  clientId,
});

export const fetch_data = (clientId, fpId) => async dispatch => {
  try {
    const response = await fetchWithDefaults(
      urlWithParams('/Consumer/ConsumerOverview/CurrentAssetAllocation', { clientId, fpId }),
      { showSpinner: true },
    );

    const { payload } = await response.json();

    dispatch(receive_current_asset_allocation_data(payload.viewData, clientId));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
};
